/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(function(algolia) {
    'use strict';
    var instantsearch = algolia.externals.instantsearch;
    var algoliasearch = algolia.externals.algoliasearch;
    var searchBox = algolia.externals.widgets.searchBox;
    var stats = algolia.externals.widgets.stats;
    var sortBy = algolia.externals.widgets.sortBy;
    var clearRefinements = algolia.externals.widgets.clearRefinements;
    var panel = algolia.externals.widgets.panel;
    var hits = algolia.externals.widgets.hits;
    var pagination = algolia.externals.widgets.pagination;
    var configure = algolia.externals.widgets.configure;
    var connectCurrentRefinements =
        algolia.externals.connectors.connectCurrentRefinements;
    var aa = algolia.externals.aa;

    var collectionPage =
        Boolean(algolia.is_collection_results_page) &&
        Boolean(algolia.config.instant_search_enabled_on_collection);

    if (
        (!algolia.full_results && !collectionPage) ||
        !algolia.config.instant_search_enabled
    ) {
        return;
    }

    /**
     * Array which will contain all filters to be applied while initiating the
     * search API call.
     */
    var searchFilters = [];

    var collectionFacetFilter = null;
    var collectionRulesContextValue = null;
    var collectionHandle = null;

    if (collectionPage) {
        var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
        collectionHandle =
            Boolean(matches) && matches.length === 2 ? matches[1] : null;

        if (algolia.config.collection_id_indexing) {
            collectionFacetFilter = algolia.current_collection_id
                ? 'collection_ids:"' + algolia.current_collection_id + '"'
                : null;
        } else {
            collectionFacetFilter = 'collections:"' + collectionHandle + '"';
        }

        // Add the collection filter to the list of search filters
        searchFilters.push(collectionFacetFilter);

        collectionRulesContextValue = algolia.config.collection_id_query_rules
            ? algolia.current_collection_id
            : collectionHandle;
    }

    // Filters for stock policy
    var stockPolicyFilter = null;
    if (algolia.config.stock_policy) {
        if (algolia.config.stock_policy === 'allow') {
            /**
             * For 'allow', we don't need to add any filter as we want to continue
             * displaying all out of stock items.
             */
        } else if (algolia.config.stock_policy === 'deny') {
            // For 'deny' we will filter out all items based on inventory quantity
            stockPolicyFilter = 'inventory_quantity > 0';
        } else if (algolia.config.stock_policy === 'continue') {
            /**
             * For 'continue' we will filter on `inventory_available` attribute whose
             * value is dependent on:
             * `inventory_quantity > 0 OR inventory_policy == 'continue'`
             */
            stockPolicyFilter = 'inventory_available:true';
        }

        // Add the stock policy filter to the list of search filters
        if (stockPolicyFilter) {
            searchFilters.push(stockPolicyFilter);
        }
    }

    var results_selector = collectionPage
        ? algolia.config.collection_css_selector
        : algolia.config.results_selector;

    var activeSortOrders =
        collectionPage && algolia.collectionSortOrders
            ? algolia.collectionSortOrders
            : algolia.sortOrders;

    results_selector += ', .algolia-shopify-instantsearch';

    function getTrackedUiState(uiState) {
        var trackedUiState = {};
        Object.keys(uiState).forEach(function(k) {
            if (k === 'configure' || k === 'query' || k === 'q') {
                return;
            }
            trackedUiState[k] = uiState[k];
        });
        return trackedUiState;
    }

    function singleIndex(indexName) {
        return {
            stateToRoute: function(uiState) {
                var route = getTrackedUiState(uiState[indexName] || {});
                route.q = uiState[indexName].query;
                return route;
            },
            routeToState: function(routeState) {
                var state = {};
                state[indexName] = getTrackedUiState(routeState || {});
                state[indexName].query = routeState.q;
                return state;
            },
        };
    }

    var instant = {
        colors: algolia.config.colors,
        distinct: Boolean(algolia.config.show_products),
        facets: {
            hidden:
                collectionPage && algolia.collectionHiddenFacets
                    ? algolia.collectionHiddenFacets
                    : algolia.hiddenFacets,
            shown:
                collectionPage && algolia.collectionShownFacets
                    ? algolia.collectionShownFacets
                    : algolia.shownFacets,
            list:
                collectionPage && algolia.collectionFacets
                    ? algolia.collectionFacets
                    : algolia.facets,
            widgets:
                collectionPage && algolia.collectionFacetsWidgets
                    ? algolia.collectionFacetsWidgets
                    : algolia.facetsWidgets,
        },
        hitsPerPage:
            collectionPage && algolia.config.collections_full_results_hits_per_page
                ? algolia.config.collections_full_results_hits_per_page
                : algolia.config.products_full_results_hits_per_page,
        poweredBy: algolia.config.powered_by,
        search: instantsearch({
            searchClient: algoliasearch(
                algolia.config.app_id,
                algolia.config.search_api_key
            ),
            indexName: (algolia.current_collection_handle === "short-squat-stands" ||
                        algolia.current_collection_handle === "high-squat-stands" ||
                        algolia.current_collection_handle === "barbells") ? 'products_price_asc' : algolia.config.index_prefix + 'products',
            routing: {

                stateMapping: (algolia.current_collection_handle === "short-squat-stands" ||
                               algolia.current_collection_handle === "high-squat-stands" ||
                               algolia.current_collection_handle === "barbells") ? singleIndex('products_price_asc')
                              : singleIndex(algolia.config.index_prefix + 'products'),
            },
            searchFunction: function(searchFunctionHelper) {
                // Set query parameters here because they're not kept when someone
                // presses the Back button if set in the `init` function of a custom widget
                var page = searchFunctionHelper.getPage();
                searchFunctionHelper.setQueryParameter(
                    'highlightPreTag',
                    '<span class="ais-highlight">'
                );
                searchFunctionHelper.setQueryParameter('highlightPostTag', '</span>');
                if (instant.distinct) {
                    searchFunctionHelper.setQueryParameter('distinct', true);
                }

                if (typeof getCookie !== 'undefined') {
                    var countryCode = getCookie('country_code');
                    if (countryCode) {
                        var filterValue = "NOT tags:" + (countryCode === 'US' ? 'INTL' : 'USA');
                        if (!searchFilters.includes(filterValue)) {
                            searchFilters.push(filterValue);
                        }
                    }
                }

                // Assign any required filters
                if (searchFilters.length) {
                    searchFunctionHelper.setQueryParameter(
                        'filters',
                        searchFilters.join(' AND ')
                    );
                }

                // Assign any required `ruleContexts` which are required for query rules
                // targeting collection pages
                if (collectionPage) {
                    // Collection page merchandising:
                    // If we are on a collection page, `collectionRulesContextValue` is defined
                    if (collectionRulesContextValue) {
                        searchFunctionHelper.setQueryParameter('ruleContexts', [
                            collectionRulesContextValue.toString(),
                        ]);
                    } else {
                        searchFunctionHelper.setQueryParameter('ruleContexts', []);
                    }
                }

                searchFunctionHelper.setPage(page);
                searchFunctionHelper.search();
            },
        }),
        selector: results_selector + ', .algolia-shopify-instantsearch',
        sortOrders: activeSortOrders,
        storeName: algolia.storeName,
        templates: {
            currentItem: algolia.getTemplate(
                'instant_search_current_refined_values_item'
            ),
            empty: algolia.getTemplate('instant_search_no_result'),
            page: algolia.compileTemplate('instant_search'),
            product: algolia.getTemplate('instant_search_product'),
            stats: algolia.getTemplate('instant_search_stats'),
            style: algolia.compileTemplate('instant_search.css'),
        },
    };

    algolia.instantsearch = instant;

    if (instant.poweredBy) {
        // eslint-disable-next-line no-console
        console.log('Algolia: Instant-Search');
    }

    function readjust() {
        var width = instant.$results.offsetWidth;

        var suffix = 'lg';
        if (width < 400) suffix = 'xs';
        else if (width < 1201) suffix = 'sm';
        //else if (width < 1200) suffix = 'md';

        instant.$results.classList.remove('ais-results-size-xs');
        instant.$results.classList.remove('ais-results-size-sm');
        instant.$results.classList.remove('ais-results-size-md');
        instant.$results.classList.remove('ais-results-size-lg');
        instant.$results.classList.add('ais-results-size-' + suffix);
    }

    // Bind helpers
    var helpers = algolia.assign(
        {},
        algolia.helpers,
        algolia.translation_helpers
    );
    Object.keys(helpers).forEach(function(name) {
        var helper = helpers[name];
        instant.search.templatesConfig.helpers[name] = helper;
    });
    instant.search.templatesConfig.compileOptions = algolia.hoganOptions;

    algolia.appendStyle(
        algolia.render(instant.templates.style, {
            distinct: instant.distinct,
            colors: instant.colors,
        })
    );

    if (collectionPage) {
        if (
            document.querySelectorAll(algolia.config.collection_css_selector)
                .length === 0
        ) {
            throw new Error(
                'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
            );
        }
    } else if (
        document.querySelectorAll(algolia.config.results_selector).length === 0
    ) {
        throw new Error(
            'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
        );
    }

    instant.$results = document.querySelector(instant.selector);

    instant.$results.innerHTML = algolia.render(instant.templates.page, {
        facets: instant.facets.list,
        storeName: instant.storeName,
        translations: algolia.translations,
        multipleSortOrders: activeSortOrders.length > 1,
    });

    // hide empty facets
    instant.search.on('render', function () {
        var emptyFacetSelector = '.ais-RefinementList--noRefinement';
        var emptyFacets = document.querySelectorAll(emptyFacetSelector);
        emptyFacets.forEach(function (elem) {
            var parent = elem.parentNode.parentNode;
            if (parent.classList.contains('ais-facet-promotions')) return;
            parent.style.display = 'none';
            if($('.ships_within_24_hours_prom').css('display') === 'none'
                && $('.free_shipping_prom').css('display') === 'none'
                && $('.sale_prom').css('display') === 'none' ) {
                $('.promotions-facet-wrapper').hide();
            } else {
                $('.promotions-facet-wrapper').show();
            }
        });

        var nonEmptyFacetSelector = '.ais-RefinementList:not(.ais-RefinementList--noRefinement)';
        var nonEmptyFacets = document.querySelectorAll(nonEmptyFacetSelector);
        nonEmptyFacets.forEach(function (elem) {
            elem.parentNode.parentNode.style.display = 'block';
        });
        if($('.ships_within_24_hours_prom').css('display') !== 'none'
            || $('.free_shipping_prom').css('display') !== 'none'
            || $('.sale_prom').css('display') !== 'none' ) {
            $('.promotions-facet-wrapper').show();
        }

        /*
        if (window.jdgm) {
            var data;
            data = $.map($('.jdgm-badge-placeholder'), function(element) {
                var hash = {};
                var $element = $(element);
                hash['productHandle'] = $element.data('handle');
                hash['badgePlaceholder'] ='.jdgm-badge-placeholder[data-handle="' + $element.data('handle') + '"]';
                return hash;
            });
            setTimeout( function(){
                window.jdgm.batchRenderBadges(data);
            }, 500);
        }
        */
    });

    readjust();

    window.addEventListener('resize', function() {
        readjust();
    });

    // Mobile facets display
    var mobileContainer = window.screen.width < 1000 ? '.ais-clear-refinements-container-small' :'.ais-clear-refinements-container-medium'
    instant.search.addWidgets([
        {
            init: function() {
                var $button = document.querySelector('.ais-facets-button');
                var $closeButton = document.querySelector('.ais-sort-close');
                var $select = document.querySelector('.ais-sort-small');
                var $applyButton = document.querySelector('.ais-facets-apply-button');
                $button.addEventListener('click', function() {
                    var $facets = document.querySelector('.ais-facets');

                    if ($facets.classList.contains('ais-facets__shown')) {
                        $button.textContent = 'Filter By';
                        $closeButton.style.display = 'none';
                        $facets.classList.remove('ais-facets__shown');
                        $select.style.display = 'block';


                    } else {
                        $closeButton.style.display = 'block';
                        $select.style.display = 'none';
                        $facets.classList.add('ais-facets__shown');
                    }
                });
                $closeButton.addEventListener('click', function() {
                    var $facets = document.querySelector('.ais-facets');

                    if ($facets.classList.contains('ais-facets__shown')) {
                        $select.style.display = 'block';
                        $closeButton.style.display = 'none';
                        $facets.classList.remove('ais-facets__shown');
                    }
                });
                $applyButton.addEventListener('click', function() {
                    var $facets = document.querySelector('.ais-facets');
                    if ($facets.classList.contains('ais-facets__shown')) {
                        //$button.textContent = 'Filter By';
                        $select.style.display = 'block';
                        $closeButton.style.display = 'none';
                        $facets.classList.remove('ais-facets__shown');
                    }
                });

            },
        },

    ]);

    instant.search.addWidgets([
        configure({
            hitsPerPage: instant.hitsPerPage,
            clickAnalytics: true,
            facetingAfterDistinct: false//Boolean(algolia.config.show_products),
        }),
    ]);

    // Search input
    instant.search.addWidgets([
        searchBox({
            container: '.ais-search-box-container',
            placeholder: algolia.translations.searchForProduct,
            showReset: false,
            showSubmit: false,
        }),
    ]);

    // Logo & clear
    instant.search.addWidgets([
        {
            init: function(opts) {
                if (!instant.poweredBy) {
                    document.querySelector('.ais-algolia-icon').style.display = 'none';
                }
                document
                    .querySelector('.ais-clear-input-icon')
                    .addEventListener('click', function() {
                        opts.helper.setQuery('').search();
                        var input = document.querySelector('.ais-search-box--input');
                        input.value = '';
                        input.focus();
                    });
            },
            render: function(opts) {
                if (!opts.state.query) {
                    if (instant.poweredBy) {
                        document.querySelector('.ais-algolia-icon').style.display = '';
                    }
                    document.querySelector('.ais-clear-input-icon').style.display =
                        'none';
                } else {
                    document.querySelector('.ais-clear-input-icon').style.display = '';
                    document.querySelector('.ais-algolia-icon').style.display = 'none';
                }
            },
        },
    ]);

    // Stats
    instant.search.addWidgets([
        stats({
            container: '.ais-stats-container',
            templates: {
                text: instant.templates.stats,
            },
        }),
    ]);

    // Sort orders
    if (activeSortOrders.length > 1) {
        instant.search.addWidgets([
            sortBy({
                container: '.ais-sort-orders-container',
                items: instant.sortOrders,
            }),
        ]);
        var widget = instant.search.addWidgets([
            sortBy({
                container: '.ais-sort-orders-container-small',
                items: instant.sortOrders,
            }),
        ]);
        widget.on('render', function (e) {
            $('.ais-SortBy-select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true
            });
            $('.ais-SortBy-select').on('select2:select', function (e) {
                this.dispatchEvent(new Event('change'));
            });
            $('.search-page .section-search, .collection-page .collection__content').css({ minHeight: 0 });
        });
    }

    // Change display
    instant.search.addWidgets([
        {
            init: function() {
                document
                    .querySelector('.ais-search-header .ais-change-display-block')
                    .addEventListener('click', function() {
                        document
                            .querySelector(
                                '.ais-change-display-block:not(.ais-change-display-selected)'
                            )
                            .classList.add('ais-change-display-selected');
                        document
                            .querySelector(
                                '.ais-change-display-list.ais-change-display-selected'
                            )
                            .classList.remove('ais-change-display-selected');
                        document
                            .querySelector('.ais-results-as-list')
                            .classList.replace('ais-results-as-list', 'ais-results-as-block');
                    });
                document
                    .querySelector('.ais-search-header .ais-change-display-list')
                    .addEventListener('click', function() {
                        document
                            .querySelector(
                                '.ais-change-display-list:not(.ais-change-display-selected)'
                            )
                            .classList.add('ais-change-display-selected');
                        document
                            .querySelector(
                                '.ais-change-display-block.ais-change-display-selected'
                            )
                            .classList.remove('ais-change-display-selected');
                        document
                            .querySelector('.ais-results-as-block')
                            .classList.replace('ais-results-as-block', 'ais-results-as-list');
                    });
            },
        },
    ]);

    // Hidden facets
    var list = instant.facets.hidden.map(function(facet) {
        return facet.name;
    });
    var facetsWidget = instant.search.addWidgets([
        {
            getConfiguration: function() {
                return {
                    facets: list,
                    disjunctiveFacets: list,
                };
            },
            init: function() {},
        },
    ]);
    facetsWidget.on('render', function (e) {
        if ($('.ais-facets .ais-facet .ais-facet--item').length) {
            $('.ais-facets > div').css({minHeight: 0});
        }
    });

    // Create the render function
    var createDataAttribtues = function(refinement) {
        return Object.keys(refinement)
            .map(function(key) {
                return 'data-' + key + '="' + refinement[key] + '"';
            })
            .join(' ');
    };

    var renderListItem = function(item) {
        var facet = instant.facets.list.find(function(f) {
            return f.name === item.label;
        });

        return item.refinements
            .map(function(refinement) {

                if(refinement.label.includes(':')){
                    var label = refinement.label.split(':');
                    refinement.label = '$' + label[0] + ' - ' + '$' + label[1];
                } else if (refinement.attribute === 'inventory_available') {
                    refinement.label = refinement.value === 'true' ? 'In Stock' : 'Out of Stock';
                } else if (refinement.attribute === 'meta.custom_fields.ships_within_24_hours') {
                    refinement.label = 'Ships within 24 hours';
                } else if (refinement.attribute === 'meta.custom_fields.free_shipping') {
                    refinement.label = 'Free shipping';
                } else if (refinement.attribute === 'meta.custom_fields.sale') {
                    refinement.label = 'Sale';
                } else if (refinement.attribute === 'collections') {
                    var collectionHandles = algolia.collection_facet.split('|'),
                        collectionNames = algolia.collection_facet_names.split('|');
                    for (var i = 0; i < collectionHandles.length; i++) {
                        if (collectionHandles[i] === refinement.value) {
                            refinement.label = collectionNames[i] || "";
                        }
                    }
                } else if (refinement.attribute === 'price') {
                    refinement.label = refinement.label.replace('≤ ', '≤ $').replace('≥ ', '≥ $');
                }

                return (
                    '<li class="ais-current-refined-values--item">' +
                    '  <a ' +
                    createDataAttribtues(refinement) +
                    '    class="ais-current-refined-values--link">' +
                    '    <div>' +
                    '      <div class="ais-current-refined-values--label">' +

                    '      </div> ' +
                    refinement.label +

                    '    </div>' +
                    ' <span class="ais-page-close">' +

                    '      </span> ' +

                    '  </a>' +
                    '</li>'
                );
            })
            .join('');
    };

    var renderCurrentRefinements = function(renderOptions) {
        var items = renderOptions.items;
        var refine = renderOptions.refine;
        var widgetParams = renderOptions.widgetParams;

        widgetParams.container.innerHTML =

            '<div class="ais-current-refined-values--header ais-facet--header ais-header">Active filters:</div>' +
            '<div class="ais-root ais-current-refined-values ais-facet">' +
            '  <ul class="ais-current-refined-values--list">' +
            items.map(renderListItem).join('') +
            '  </ul>' +
            '</div>';
        var facetsCount = Array.prototype.slice
            .call(
                widgetParams.container.querySelectorAll(
                    '.ais-current-refined-values--link'
                )
            )
        if(facetsCount.length > 0) {
            document.querySelector('.ais-facets-number').innerHTML = '(' + facetsCount.length + ')';
        }
        Array.prototype.slice
            .call(
                widgetParams.container.querySelectorAll(
                    '.ais-current-refined-values--link'
                )
            )
            .forEach(function(element) {
                element.addEventListener('click', function(event) {
                    var item = Object.keys(event.currentTarget.dataset).reduce(function(
                        acc,
                        key
                        ) {
                            var itemData = {};
                            itemData[key] = event.currentTarget.dataset[key];
                            return algolia.assign({}, acc, itemData);
                        },
                        {});

                    refine(item);
                });
            });
    };

    // Create the custom widget
    var customCurrentRefinements = connectCurrentRefinements(
        renderCurrentRefinements
    );

    var hasRefinements = function(helper, facetsList) {
        document.querySelector('.ais-facets-number').innerHTML = '';
        return facetsList.some(function(f) {
            var isConjunctiveFacetRefined =
                helper.state.isConjunctiveFacet(f.name) &&
                helper.state.isFacetRefined(f.name);
            var isDisjunctiveFacetRefined =
                helper.state.isDisjunctiveFacet(f.name) &&
                helper.state.isDisjunctiveFacetRefined(f.name);
            var isHierarchicalFacetRefined =
                helper.state.isHierarchicalFacet(f.name) &&
                helper.state.isHierarchicalFacetRefined(f.name);

            var numericRefinements = helper.state.getNumericRefinements(f.name);
            var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
                operator
            ) {
                return numericRefinements[operator].length > 0;
            });

            return (
                isNumericFacetRefined ||
                isConjunctiveFacetRefined ||
                isDisjunctiveFacetRefined ||
                isHierarchicalFacetRefined
            );
        });
    };

    var customCurrentRefinementsWithPanel = panel({
        hidden: function(options) {
            return !hasRefinements(options.helper, instant.facets.list);
        },
    })(customCurrentRefinements);

    var clearRefinementsWithPanel = panel({
        hidden: function(options) {
            return !hasRefinements(options.helper, instant.facets.list);
        },
    })(clearRefinements);

    if (window.screen.width < 1000 ) {
        instant.search.addWidgets([
            clearRefinementsWithPanel({
                container: document.querySelector(mobileContainer),
                templates: {
                    resetLabel: algolia.translations.clearAll,
                },
            }),
            customCurrentRefinementsWithPanel({
                container: document.querySelector(
                    '.ais-current-refined-values-container-medium'
                ),
            }),
        ])
    } else if (window.screen.width < 1200 && window.screen.width > 1000) {
        instant.search.addWidgets([
            clearRefinementsWithPanel({
                container: document.querySelector(mobileContainer),
                templates: {
                    resetLabel: algolia.translations.clearAll,
                },
            }),

            customCurrentRefinementsWithPanel({
                container: document.querySelector(
                    '.ais-current-refined-values-container-medium'
                ),
            }),

        ]);

    } else {
        instant.search.addWidgets([
            clearRefinementsWithPanel({
                container: document.querySelector('.ais-clear-refinements-container'),
                templates: {
                    resetLabel: algolia.translations.clearAll,
                },
            }),
            customCurrentRefinementsWithPanel({
                container: document.querySelector(
                    '.ais-current-refined-values-container'
                ),
            }),

        ]);
    }



    // Facets
    instant.facets.widgets.forEach(function(widget) {
        instant.search.addWidgets([widget.widget(widget.params)]);
    });

    // Hits
    instant.search.addWidgets([
        hits({
            container: '.ais-hits-container',
            templates: {
                empty: instant.templates.empty,
                item: instant.templates.product,
            },
            transformItems: function(products) {
                return products.map(function(product) {
                    return algolia.assign({}, product, {
                        _distinct: instant.distinct,
                        can_order:
                            product.inventory_management !== 'shopify' ||
                            product.inventory_policy === 'continue' ||
                            product.inventory_quantity > 0,
                        translations: algolia.translations,
                        queryID: product.__queryID,
                        productPosition: product.__position,
                        index: instant.search.mainIndex.getIndexName(),
                        labelData: 100 - (+product.price_ratio.toFixed(2) * 100).toFixed(0),
                        freeShipping: product.meta.custom_fields !== undefined && product.meta.custom_fields.free_shipping === 1 || product.tags.includes("free shipping"),
                        newProduct: product.collections.includes("new-equipment"),
                        preOrder: product.tags.includes("preorder-only"),
                        notAvailableForSale: product.meta.custom !== undefined && product.meta.custom['not_available_for_sale'],
                        learningLink: product.meta.custom_fields !== undefined && product.meta.custom_fields['stealth_learning_link'],
                        isHaveOptions: product.option_names.length > 0,
                        productSrc: (product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '310x' + '.$2') + ' 3000w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '310x' + '.$2') + ' 2000w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '310x' + '.$2') + ' 1900w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '300x' + '.$2') + ' 1600w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '250x' + '.$2') + ' 1400w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '250x' + '.$2') + ' 1200w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '240x' + '.$2') + ' 1000w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '200x' + '.$2') + ' 600w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '200x' + '.$2') + ' 200w, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '310x@2x' + '.$2') + ' 2x, ' +
                            product.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + '310x@3x' + '.$2') + ' 3x, ' )
                    });
                });
            },
        }),
    ]);

    // Redirect to product on click
    instant.search.addWidgets([
        {
            init: function() {
                var container = document.querySelector('.ais-hits-container');
                container.addEventListener('click', function(e) {
                    var el = e.target;
                    var hit;
                    do {
                        if (el.matches('.ais-hit')) {
                            hit = el;
                            break;
                        }
                        if (el.matches('.ais-hit--cart-button')){
                            return;
                        }
                        el = el.parentNode;

                    } while (el && el !== container);
                    if (!hit) {
                        return;
                    }
                    var $this = hit;
                    var productHandle = $this.dataset.handle;
                    var variant_id = $this.dataset.variantId;
                    var distinct = $this.dataset.distinct;

                    // Construct the link we should redirect to
                    var link = '';

                    // If we're on a collection page and the handle is available
                    // then prefix the product link with the collection handle
                    if (collectionPage && collectionHandle) {
                        link = '/collections/' + collectionHandle;
                    }

                    // Add the product handle to the link
                    link = link + '/products/' + productHandle;

                    // Add the variant ID details to redirect to a specific
                    // variant ID if we are showing variants and not products
                    if (distinct !== 'true') {
                        link += '?variant=' + variant_id;
                    }

                    if (algolia.config.analytics_enabled) {
                        var clickData = {
                            index: hit.dataset.algoliaIndex,
                            eventName: 'click',
                            queryID: hit.dataset.algoliaQueryid,
                            objectIDs: [hit.dataset.algoliaObjectid],
                            positions: [Number(hit.dataset.algoliaPosition)],
                        };

                        // Send the click event
                        aa.clickedObjectIDsAfterSearch(clickData);
                        /**
                         * Uncomment the following function call to start storing data in
                         * local storage for conversion tracking
                         */
                        algolia.saveForConversionTracking(clickData);
                    }
                    window.location.href = link;
                });
            },
        },
    ]);

    // Add to cart
    instant.search.addWidgets([
        {
            init: function() {

                var container = document.querySelector('.ais-hits-container');
                var listener = function(e) {
                    var el = e.target;
                    var cartButton;
                    do {
                        if (el.matches('.ais-hit--cart-button')) {
                            cartButton = el;
                            break;
                        }
                        el = el.parentNode;
                    } while (el && el !== container);
                    if (!cartButton) {
                        return;
                    }

                    e.stopPropagation();
                    var $this = cartButton;
                    var formId = $this.dataset.formId;
                    var productId = document.getElementById(formId).querySelector('[name="id"]').value;
                    if (formId) {
                       $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: {
                                quantity: 1,
                                id: productId,
                                form_type: 'product'
                            },
                            dataType: 'json',
                            success: function () {
                                Shopify.theme.jsAjaxCart.updateView();
                                Shopify.theme.jsAjaxCart.showDrawer();
                            }
                        });
                    }
                };
                  container.addEventListener('click', listener);
            },
        },
    ]);

    // No result actions
    instant.search.addWidgets([
        {
            init: function(opts) {
                var container = document.querySelector('.ais-hits-container');
                container.addEventListener('click', function(e) {
                    var el = e.target;
                    var clearFilters;
                    do {
                        if (el.matches('.ais-hit-empty--clear-filters')) {
                            clearFilters = el;
                            break;
                        }
                        el = el.parentNode;
                    } while (el && el !== container);
                    if (!clearFilters) {
                        return;
                    }

                    var helper = opts.helper;
                    helper.clearTags();
                    instant.facets.list.forEach(function(facet) {
                        helper.clearRefinements(facet.name);
                    });
                    helper.search();
                });

                container.addEventListener('click', function(e) {
                    var el = e.target;
                    var clearInput;
                    do {
                        if (el.matches('.ais-hit-empty--clear-input')) {
                            clearInput = el;
                            break;
                        }
                        el = el.parentNode;
                    } while (el && el !== container);
                    if (!clearInput) {
                        return;
                    }

                    opts.helper.setQuery('').search();
                    var input = document.querySelector('.ais-search-box--input');
                    input.value = '';
                    input.focus();
                });
            },
        },
    ]);

    // Pagination
    instant.search.addWidgets([
        pagination({
            container: '.ais-pagination-container',
            padding: 2,
            maxPages: 20,
        }),
    ]);

    // Main
    instant.search.start();

    instant.search.on('render', () => {
        const panel = document.querySelector('[data-cta-panel]');
        const parentElement = document.querySelector('.ais-Hits-list');
        if(parentElement && panel) {
            const copyPanel = panel.cloneNode(true);
            if(!parentElement.querySelector('[data-cta-panel]')) {
                parentElement.insertAdjacentElement('afterbegin', copyPanel);
                parentElement.querySelector('[data-cta-panel]').style.display = '';
            }
        }
    });


    algolia.contentHide.parentNode.removeChild(algolia.contentHide);
})(window.algoliaShopify);


window.onload = function() {
    // window.yotpo.refreshWidgets();
}
